import { PageLoader } from "@einride/ui"
import { RootLayout } from "pages/RootLayout"
import ShipmentsPage from "pages/ShipmentsPage/ShipmentsPage"
import { lazy, Suspense } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

const HomePage = lazy(() => import("pages/HomePage/HomePage"))
const ReportsPage = lazy(() => import("pages/ReportsPage/ReportsPage"))
const ReportPage = lazy(() => import("pages/ReportPage/ReportPage"))

export const App = (): React.JSX.Element => {
  return (
    <Suspense fallback={<PageLoader />}>
      <BrowserRouter>
        <Routes>
          <Route element={<RootLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/reports/:id" element={<ReportPage />} />
            <Route path="/shipments" element={<ShipmentsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  )
}
